import { useEffect, useState } from "react"

import { proposalHttpController } from "@garantidos/services"
import { trackEvent } from "@garantidos/utils/tracking"

import { useProposalContext } from "contexts/proposal"

import * as trackers from "./trackings"

const useLikerComponent = () => {
  const { cpfData, errorHandler } = useProposalContext()

  const { hashedCpf } = cpfData

  const [eventLabel, setEventLabel] = useState("")
  const [experienceTrack, setExperienceTrack] = useState("")

  const handleSubmitCallback = async ({ experience, description }) => {
    setEventLabel("CliqueEnviar")
    const nonTagsDescription = description.replace(/</g, "").replace(/>/g, "")
    const event = { segment: `${experience} - ${nonTagsDescription}` }
    trackEvent(event)
    trackers.likert(hashedCpf, eventLabel, experienceTrack)
    try {
      const payload = {
        likert_rate: experience,
        likert_comment: description
      }
      await proposalHttpController({ payload, method: "sendLikert" })
    } catch (error) {
      errorHandler(error)
    }
  }

  const handleExperienceCallback = ({ experience }) => {
    setExperienceTrack(experience)
    setEventLabel(`CliqueExperiencia${experience}`)
  }

  const handleOptionCallback = ({ option }) => {
    setEventLabel(`CliqueMelhoria${option}`)
  }

  return {
    handleSubmitCallback,
    handleExperienceCallback,
    handleOptionCallback
  }
}

export default useLikerComponent
